module.exports = __webpack_public_path__ + "static/oldpaper2-filled2-18377b40a2ccfc9e23757ee69c9b97ab.png";